import React from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import ImagenDialogo from "../../../images/modulo14/dialogopreincas.png";
import ImagenMonica from "../../../images/modulo14/und7act3.png";

const QueHablamosObservamos = () => {
  const infoUnidad = modulo14.content[0];
  const infoAct = modulo14.content[0].activities[2];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title:
        modulo14.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo14.content[0].name}: ${modulo14.content[0].activities[3].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[0].path}/${modulo14.content[0].activities[3].path}`,
    titlePrev: `${modulo14.content[0].name}: ${modulo14.content[0].activities[1].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[0].path}/${modulo14.content[0].activities[1].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>

      <div className="bg-light p-3 mt-5 rounded">
        <div className="row align-items-center">
          <div className="col-md-8 col-12 p-md-3 p-2">
            <h4 className="mb-4">
              <strong>¿Cuántas lenguas se hablan en el Perú?</strong>
            </h4>
            <p className="mt-1">
              El Perú ha sido un país <strong>multilingüe</strong> desde
              siempre. Mucho antes de que los españoles trajeran el castellano,
              se hablaban ya más de doscientas lenguas en nuestro territorio.
            </p>
            <p>
              Con los conquistadores españoles llegó una nueva lengua: el
              español o castellano. Esta lengua relegó al quechua, al aimara y a
              las otras lenguas originarias.
            </p>
          </div>

          <div className="col-md-4 col-12">
            <img
              src={ImagenMonica}
              className="bg-white img-fluid rounded w-100"
              alt="dialogo"
            />
          </div>
          <div className="col-md-4 col-12">
            <img
              src={ImagenDialogo}
              className="bg-white img-fluid rounded w-100"
              alt="dialogo"
            />
          </div>
          <div className="col-md-8 col-12 p-md-3 p-0">
            <p>
              Es difícil saber cuántas lenguas se hablan en el Perú. Muchas no
              han sido descritas. Otras han disminuido en su número de hablantes
              y varias se han extinguido. El
              <strong> puquina</strong>, una lengua muy importante en la época
              incaica, por ejemplo, ya no existe.
            </p>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Pida que lean en silencio el texto titulado: ¿Cuántas lenguas se
            hablan en el Perú? Luego, pídales que lean en voz alta por turnos.
            Pregunte si alguno sabe qué lengua es la que aparece en la primera
            ilustración (se trata del quechua).
          </li>
          <li>
            Pregunte por qué no sabemos con exactitud cuántas lenguas se hablan
            en el Perú. Cierre la sesión comentando que existe distinta
            información sobre el número de lenguas que hablamos en el Perú. Ello
            se debe a que muchas de estas lenguas no han sido descritas y ello
            hace que sea difícil distinguirlas de otras. Por ejemplo, si no
            tenemos información sobre una determinada lengua no sabremos si se
            trata de una nueva lengua o de una variedad de una lengua ya
            existente. Además las fronteras entre una lengua y otra a veces son
            poco claras. Esta es una de las razones por las que es difícil tener
            una cifra exacta sobre lenguas que se hablan en el Perú. Sin
            embargo, el Ministerio de Cultura ha establecido que se hablan en el
            Perú aproximadamente 47 lenguas originarias.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default QueHablamosObservamos;
